var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.info.from)+"-"+_vm._s(_vm.info.to)+" "+_vm._s(_vm.$t('components.datatable.table-info.of'))+" "+_vm._s(_vm.info.of)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }